import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { ControlValueAccessor, FormControl, NgModel, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';
import { DataItem } from '../model/data.item';

@Component({
    selector: 'input-menu',
    templateUrl: './input.menu.html',
    styleUrls: ['./input.scss'],
    providers: [
        { 
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => InputMenu),
          multi: true
        }
      ],
      // changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputMenu implements OnInit, OnChanges, ControlValueAccessor {

    text: string;
    value: any;

    selected: string | DataItem;

    @Input('lookup')
    lookup: string[] | DataItem[] = [];

    @Input('key')
    key: string;

    @Input('expression')
    expression: string;

    @Input('name')
    name: string;

    @Input('label')
    label: string;

    @Input('hint')
    hint: string;

    @Input('error-message')
    errorMessage: string;

    @Input('required')
    required: boolean;

    @Input('hidden')
    hidden: boolean;

    @Input('disabled')
    disabled: boolean;

    @Input('readonly')
    readonly: boolean;

    @Input('validator')
    validator: (value) => string; 

    error: string;

    // control: FormControl;

    ngOnInit() {
      // this.selected = this.findItem(this.value);
      // this.required = true;
      // this.control = new FormControl(this.value);

      // if (this.required) { this.control.setValidators([Validators.required]); }
      // if (this.disabled) { this.control.disable(); }
    }

    ngOnChanges(changes: SimpleChanges) {
      this.changeValue(this.value);
      // this.selected = this.findItem(this.value);
    }

    // getDisplay(event: any): string {
    //     if (!event) return null;

    //     if (this.expression) {
    //       return event[this.expression];
    //     } else {
    //       return event;
    //     }
    // }

    findItem(event: any): string | DataItem {
      for(let one of this.lookup) {
        if (typeof(one) != 'string' && one.value == event) {
          return one;
        } else {
          if (one == event) return one;
        }
      }
      // Try matching key if exact matching fails..
      if (event && this.key && event[this.key]) {
        for(let one of this.lookup) {
          if (typeof(one) != 'string' && one.value[this.key] == event[this.key]) {
            return one;
          }
        }
      }
      
      return null;
    }

    readonly errorMatcher: ErrorStateMatcher = {
      isErrorState: (ctrl: FormControl) => {
          // (ctrl && ctrl.invalid)
          // this.error = null;
          // if (this.required && (!this.value || this.value.trim().length == 0)) {
          //     this.error = 'required';
          // }
          return !!this.error;
        }
    }

    changeSelected(event: string | DataItem) {
      this.text = (typeof(event) == 'string')? event : (event)? event.name : null;
      this.value = (typeof(event) == 'string')? event : (event)? event.value : null;

      this.propagateChange(this.value);

      if (this.validator) {
        this.error = this.validator(this.value);
        return;
      }

      this.error = null;
      if (this.required && !this.value) {
        this.error = 'Value is required';
      }
    }

    changeValue(event: any) {
      this.text = (typeof(event) == 'string')? event : (event)? event.name : null;
      this.value = event;
      this.selected = this.findItem(event);
      this.propagateChange(event);

      if (this.validator) {
        this.error = this.validator(this.value);
        return;
      }

      this.error = null;
      if (this.required && !event) {
        this.error = 'Value is required';
      }
    }

    writeValue(value: any) {
      // if (value !== undefined) {
        //if (value != this.value) {
          this.changeValue(value);
        //}
        this.value = value;
      // }
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn) {
      this.propagateChange = fn;
    }

    registerOnTouched() {}
}